<template>
  <div ref="editorRef" class="pg-monaco-editor"></div>
</template>
<script setup>
import { ref, onMounted, watch, onUnmounted } from 'vue'
import { clone, setValueByPathToVue } from '../../../utils/index'
import * as monaco from 'monaco-editor'

import { language as sqlLanguage } from 'monaco-editor/esm/vs/basic-languages/sql/sql.js'
monaco.languages.registerCompletionItemProvider('sql', {
  provideCompletionItems: (model, position) => {
    let suggestions = []
    const { lineNumber, column } = position
    const textBeforePointer = model.getValueInRange({
      startLineNumber: lineNumber,
      startColumn: 0,
      endLineNumber: lineNumber,
      endColumn: column,
    })
    const contents = textBeforePointer.trim().split(/\s+/)
    const lastContents = contents[contents?.length - 1] // 获取最后一段非空字符串
    if (lastContents) {
      const sqlConfigKey = ['builtinFunctions', 'keywords', 'operators']
      sqlConfigKey.forEach((key) => {
        sqlLanguage[key].forEach((sql) => {
          suggestions.push({
            label: sql, // 显示的提示内容;默认情况下，这也是选择完成时插入的文本。
            insertText: sql, // 选择此完成时应插入到文档中的字符串或片段
            // kind: monaco.languages.CompletionItemKind['Function'], // 此完成项的种类。编辑器根据图标的种类选择图标。
          })
        })
      })
    }
    return {
      suggestions,
    }
  },
})

const props = defineProps({
  value: [String, Object, Array],
  notInput: Boolean,
  valueType: {
    type: String,
    default: 'string',
  },
  language: {
    type: String,
    default: 'json',
  },
})
const emit = defineEmits(['input'])

const tranformValue = (val) => {
  if (val && props.valueType === 'object') {
    const newVal = props.notInput ? clone(val) : val
    return JSON.stringify(newVal, null, '\t')
  } else {
    return val
  }
}
const setInput = (val) => {
  let tempVal = val
  try {
    if (val && props.valueType === 'object') {
      tempVal = JSON.parse(val)
    }
    if (props.notInput && props.valueType === 'object' && props.value) {
      const keys = tempVal ? Object.keys(tempVal) : []
      for (const key of keys) {
        setValueByPathToVue(props.value, key, tempVal[key])
      }
    } else {
      emit('input', tempVal)
    }
  } catch (e) {
    console.log(e)
  }
}

const editorRef = ref(null)
let monacoInstance = null
onMounted(() => {
  monacoInstance = monaco.editor.create(editorRef.value, {
    value: tranformValue(props.value ?? ''),
    language: props.language,
    scrollBeyondLastLine: false,
    minimap: {
      enabled: false,
    },
  })
  monacoInstance.onDidBlurEditorText(() => {
    setInput(monacoInstance.getValue())
  })
  // monacoInstance.onDidChangeModelContent(() => {
  //   setInput(monacoInstance.getValue())
  // })
})
onUnmounted(() => {
  monacoInstance.dispose()
})
watch(
  () => props.value,
  () => {
    const tempValue = tranformValue(props.value)
    if (monacoInstance && tempValue !== monacoInstance.getValue()) {
      monacoInstance.setValue(tempValue)
    }
  }
)
</script>
<style lang="scss">
.pg-monaco-editor {
  width: 100%;
  height: 100%;
  min-height: 20px;
  overflow: hidden;
  .main {
    height: 600px;
  }
}
</style>
